import getRegionalConfigurationRequest from 'owa-service/lib/factory/getRegionalConfigurationRequest';
import getRegionalConfigurationOperation from 'owa-service/lib/operation/getRegionalConfigurationOperation';
export default function getRegionalConfiguration() {
    return getRegionalConfigurationOperation(getRegionalConfigurationRequest({}));
}
//# sourceMappingURL=getMailboxRegionalConfiguration.js.map